module.exports = __webpack_public_path__ + "static/media/carbon_edit.680db5a5.svg";